import React, { useState, useEffect, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { Col, Form, FormGroup, Row } from 'reactstrap';

import ReactButton from 'components/Buttons/ReactButton';
import {
  loadObjectFromLocalStorage,
  saveObjectToLocalStorage,
  LOCAL_STORAGE_KEYS
} from 'utils/fuctions/localStorage';
import { FlexController } from 'components/FlexControllerInput';

function RecordTypeSelection({ recordTypes = [], handleOnSelectedRecordType }) {
  const { handleSubmit, control, setValue, errors } = useForm();
  const [selectedRecordType, setSelectedRecordType] = useState(null);
  const formRef = useRef(null);

  const onSelectionChange = (_fieldName, value) => {
    setSelectedRecordType(value);
    saveObjectToLocalStorage(
      LOCAL_STORAGE_KEYS.SIDEDRAWER_PROTOCOL_RECORD_TYPE_ID,
      { memorizedRecordTypeId: value }
    );
  };

  const onSubmit = () => {
    if (!selectedRecordType) return;
    handleOnSelectedRecordType(selectedRecordType);
  };

  const handleButtonClick = () => {
    saveObjectToLocalStorage({ shouldGoDirectlyToTheForm: true });
  };

  useEffect(() => {
    const memorizedRecordTypeId = loadObjectFromLocalStorage(
      LOCAL_STORAGE_KEYS.SIDEDRAWER_PROTOCOL_RECORD_TYPE_ID
    )?.memorizedRecordTypeId;

    if (
      memorizedRecordTypeId &&
      (selectedRecordType === undefined || selectedRecordType === null)
    ) {
      setSelectedRecordType(memorizedRecordTypeId);
      setValue('selectedRecordType', memorizedRecordTypeId);
    }
  }, [selectedRecordType, setValue]);

  return (
    <>
      <h1 className="mb-0 pb-0">Tipos de registro</h1>
      <Form onSubmit={handleSubmit(onSubmit)} ref={formRef}>
        <Row>
          <Col sm="12">
            <FormGroup tag="fieldset">
              <FlexController
                textoDoLabel="Selecione algum dos tipos de registro abaixo"
                type="radio"
                name="selectedRecordType"
                options={recordTypes.map((recordType) => ({
                  label: recordType.name,
                  value: recordType.id
                }))}
                valueController={onSelectionChange}
                control={control}
                rules={{ required: 'Campo obrigatório' }}
                errors={errors}
              />
            </FormGroup>
          </Col>
          <Col sm="12">
            {recordTypes && (
              <>
                <div onClickCapture={handleButtonClick}>
                  <ReactButton
                    btnColor="confirmation"
                    type="submit"
                    disabled={!selectedRecordType}
                  >
                    Selecionar
                  </ReactButton>
                </div>
              </>
            )}
          </Col>
        </Row>
      </Form>
    </>
  );
}

export default RecordTypeSelection;
